var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHandoffs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "36px",
    viewBox: "0 0 46 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "468D5339-C27C-4885-9B7D-C755592E64F4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WC-Scoreboard",
    transform: "translate(-885, -692)",
    fill: "#9E9E9E",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    transform: "translate(500, 342)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "swap_horiz---material",
    transform: "translate(385, 350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46,10.2680412 L35.8186667,20.5360825 L35.8186667,12.8041237 L17.848,12.8041237 L17.848,7.73195876 L35.8186667,7.73195876 L35.8186667,0 L46,10.2680412 Z M10.1813333,15.4639175 L10.1813333,23.1958763 L28.152,23.1958763 L28.152,28.2680412 L10.1813333,28.2680412 L10.1813333,36 L0,25.7319588 L10.1813333,15.4639175 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandoffs);
export default __webpack_public_path__ + "static/media/handoffs.6b9d6c490883622d10db8cce90189778.svg";
export { ForwardRef as ReactComponent };